import React, { useCallback, useEffect, useState } from 'react';
import { InputNumber, Select, Button, message } from 'antd';
import style from '../style.module.css'


const SettingItem = (props) => {
  const { data, deleteHandler, updateHandler, cancelHandler, defaultColor, isEditing, changeIsEditing } = props;
  const [updateParams, setUpdateParams] = useState({
    overTime: data.overTime,
    overColor: data.overColor
  });
  const [updateVisible, setUpdateVisible] = useState(false);

  useEffect(() => {
    setUpdateParams({
      overTime: data.overTime,
      overColor: data.overColor
    });
  }, [data]);

  const cancelUpdate = useCallback(() => {
    setUpdateVisible(false);
    changeIsEditing(false);
    cancelHandler();
  }, []);
  return (
    <div className={style.item}>
      {data.overTime > 0 && <InputNumber min={0} max={90} onChange={(val) => {
        if (isEditing && !updateVisible) {
          message.destroy();
          message.warning('请先保存或取消修改！');
          return;
        }
        setUpdateVisible(true);
        changeIsEditing(true);
        setUpdateParams({
          ...updateParams,
          overTime: val
        });
      }}
        value={updateParams.overTime}
        style={{ width: '80px', marginRight: '10px' }} />}
      {data.overTime > 0 ? `天及以上未发布` : `从未发布或未采集到`}，预警颜色
      <Select
        value={updateParams.overColor}
        onChange={(value) => {
          if (isEditing && !updateVisible) {
            message.destroy();
            message.warning('请先保存或取消修改！');
            return;
          }
          setUpdateVisible(true);
          changeIsEditing(true);
          setUpdateParams({
            ...updateParams,
            overColor: value
          });
        }}
        style={{ width: '100px', margin: '0 10px' }}>
        {defaultColor.map((color, index) => (
          <Select.Option value={color} key={index}>
            <div style={{ backgroundColor: `${color}`, width: '60px', height: '20px', marginTop: '5px' }}></div>
          </Select.Option>
        ))}
      </Select>
      <Button type='danger' onClick={() => {
        if (isEditing && !updateVisible) {
          message.destroy();
          message.warning('请先保存或取消修改！');
          return;
        }
        deleteHandler(data.id)
      }} style={{ margin: '0 10px' }}>删除</Button>
      {updateVisible &&
        <>
          <Button type='primary' onClick={() => {
            updateHandler({
              id: data.id,
              overTime: updateParams.overTime,
              overColor: updateParams.overColor
            });
            cancelUpdate();
          }}>确认</Button>
          <Button onClick={() => {
            cancelUpdate();
          }} style={{ margin: '0 10px' }}>取消</Button>
        </>
      }
    </div>
  )
}

export default SettingItem